import { render, staticRenderFns } from "./ItemElementShops.vue?vue&type=template&id=4a8d6286&scoped=true"
import script from "./ItemElementShops.vue?vue&type=script&lang=ts"
export * from "./ItemElementShops.vue?vue&type=script&lang=ts"
import style0 from "./ItemElementShops.vue?vue&type=style&index=0&id=4a8d6286&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8d6286",
  null
  
)

export default component.exports